import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { initializeUiTheme } from '../hooks/use-ui-theme';
import '../styles/globals.css';
import './styles/mission-control.css';
initializeUiTheme();
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(ErrorBoundary, { children: _jsx(App, {}) }) }));
